import { render, staticRenderFns } from "./ConsultaDinamica.vue?vue&type=template&id=287b7ff6&scoped=true"
import script from "./ConsultaDinamica.vue?vue&type=script&lang=js"
export * from "./ConsultaDinamica.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDinamica.vue?vue&type=style&index=0&id=287b7ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b7ff6",
  null
  
)

export default component.exports